<template src="./LiberarArquivos.html"></template>
<style scoped src="./LiberarArquivos.css"></style>

<script>
import * as Arquivos from "../../../providers/arquivos.service";
export default {
  props: {
    clientes: {
      type: Array()
    },
    closeDialog: {
      type: Function
    }
  },
  data() {
    return {
      aCriterio: [],
      criterios: [
        { value: 2, text: "Download Silencioso" },
        { value: 0, text: "Critério do Cliente" },
        { value: 1, text: "Instalação Forçada" }
      ],
      arquivosArr: [],
      selecionados: [],
      mensagem: "",
      snackbar: false,
      snackbarColor: "info"
    };
  },
  created() {
    var self = this;
    Arquivos.getArquivos().then(resp => {
      resp.forEach(el => {
        if (
          (el.ARQTIPO == 1 ||
            el.ARQTIPO == 2 ||
            el.ARQTIPO == 3 ||
            el.ARQTIPO == 4) &&
          el.ARQATIVO == 1
        )
          self.arquivosArr.push(el);
        self.aCriterio.push(0);
      });
    });
  },
  watch: {
    open() {
      this.sheet = open;
    }
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    liberar() {
      var ncliente = [];
      this.clientes.forEach(element => {
        ncliente.push(element.CLICODIGO);
      });
      var body = {
        clientes: ncliente,
        arquivos: this.selecionados
      };
      Arquivos.liberaArquivos(body).then(r => {
        if (r.Error) {
          this.mensagem = "Arquivo já liberado.";
          this.snackbar = true;
          this.snackbarColor = "error";
        } else {
          this.mensagem = "Sucesso!";
          this.snackbar = true;
          this.snackbarColor = "success";
        }
        this.sheet = false;

        const snackbar = {
          mensagem: this.mensagem,
          snackbar: this.snackbar,
          snackbarColor: this.snackbarColor
        };
        this.closeDialog(snackbar);
      });
    },
    checkArquivo(item) {
      var self = this;
      var exist = self.selecionados.includes(item);
      !exist ? self.selecionados.push(item) : self.selecionados.remove(item);
    }
  }
};
</script>